export const isAscii = (string) => Array.from(string).every((char) => char.codePointAt(0) < 256);

export const toBinary = (string) => {
  const codeUnits = new Uint16Array(string.length);
  for (let i = 0; i < codeUnits.length; i += 1) {
    codeUnits[i] = string.charCodeAt(i);
  }
  return String.fromCharCode(...new Uint8Array(codeUnits.buffer));
};



// WEBPACK FOOTER //
// ./utils/ascii-helper.js